import React, { forwardRef } from 'react';

interface InviteFieldInlineProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder?: string;
  disabled?: boolean;
  buttonText?: string;
}

const InviteFieldInline = forwardRef<HTMLInputElement, InviteFieldInlineProps>(({
  value,
  onChange,
  onSubmit,
  placeholder = "your@email.com",
  disabled = false,
  buttonText = "Request Code"
}, ref) => {
  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <input
        ref={ref}
        type="email"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
        placeholder={placeholder}
        disabled={disabled}
        style={{
          flex: 1,
          fontSize: '16px',
          lineHeight: 1,
          padding: '14px',
          borderRadius: '12px',
          border: '2px solid transparent',
          outline: 'none',
          color: '#0e1a19',
          background: 'rgba(255,255,255,0.92)',
          boxShadow: '0 4px 10px rgba(2,13,12,0.16) inset',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = '#1cb69a';
          e.target.style.boxShadow = '0 0 0 3px rgba(28,182,154,0.25)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = 'transparent';
          e.target.style.boxShadow = '0 4px 10px rgba(2,13,12,0.16) inset';
        }}
      />
      <button
        onClick={onSubmit}
        disabled={disabled}
        style={{
          background: '#1cb69a',
          border: 'none',
          color: '#04211c',
          fontWeight: 700,
          padding: '14px 18px',
          borderRadius: '12px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          boxShadow: '0 10px 20px rgba(28,182,154,0.25)',
          opacity: disabled ? 0.6 : 1,
          transform: 'translateY(0)',
          transition: 'all 0.1s ease',
        }}
        onMouseEnter={(e) => !disabled && (e.currentTarget.style.filter = 'brightness(1.05)')}
        onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
        onMouseDown={(e) => !disabled && (e.currentTarget.style.transform = 'translateY(1px)')}
        onMouseUp={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
      >
        {buttonText}
      </button>
    </div>
  );
});

InviteFieldInline.displayName = 'InviteFieldInline';

export default InviteFieldInline;